import { useState } from "react";
import type { Faq } from "@/types/content";

interface FaqAccordionProps {
  items: Faq[];
}

export default function FaqAccordion({ items }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item, index) => {
        const open = openIndex === index;
        return (
          <div key={item.question}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(open ? null : index)}
                aria-expanded={open}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
              >
                <span className="flex items-center gap-3 font-heading text-sm font-semibold text-foreground-950 md:text-base">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-accent-100 text-xs font-bold text-accent-800">
                    Q
                  </span>
                  {item.question}
                </span>
                <span className="flex h-6 w-6 shrink-0 items-center justify-center text-foreground-500">
                  <i
                    className={`${open ? "ri-subtract-line" : "ri-add-line"} w-5 h-5 flex items-center justify-center`}
                  ></i>
                </span>
              </button>
            </h3>
            {open && (
              <div className="px-5 pb-5 pl-14">
                <p className="text-sm leading-relaxed text-foreground-600">{item.answer}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}